/* eslint-disable no-unused-vars */
import { RepositoryError } from "@invoiceddd/domain";
import { Context, Effect } from "effect";

/**
 * Repository interface for invoice number operations.
 * This port defines the contract for invoice number persistence operations.
 *
 * @interface InvoiceNumberRepository
 * @since 0.1.0
 * @see {@link RepositoryError}
 * @example
 * import { InvoiceNumberRepository } from '@invoiceddd/application';
 * // Inject implementation at runtime
 */
export interface InvoiceNumberRepositorySchema {
  /**
   * Check if an invoice number already exists in the system.
   * @param invoiceNumber The invoice number to check
   * @returns Effect that resolves to true if exists, false otherwise
   * @since 0.1.0
   * @example
   * const exists = await invoiceNumberRepository.existsByInvoiceNumber('INV-2025-001')
   */
  readonly existsByInvoiceNumber: (
    _invoiceNumber: string
  ) => Effect.Effect<boolean, RepositoryError>;
}

/**
 * Context tag for InvoiceNumberRepository service.
 * Used for dependency injection.
 * @since 0.1.0
 * @see {@link InvoiceNumberRepository}
 */
/**
 * Context tag for InvoiceNumberRepository service.
 * Used for dependency injection.
 * @since 0.1.0
 * @see {@link InvoiceNumberRepository}
 */
export class InvoiceNumberRepository extends Context.Tag("@/applayer/ports/InvoiceNumberRepository")<
  InvoiceNumberRepository,
  InvoiceNumberRepositorySchema
>() {}
